import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import styles from "../../Styles/Itinerary.module.scss";
import itinerary from "../../img/England/Itinerary_England.pdf";
import { IoClose } from "react-icons/io5";
import pictureOne from "./../../img/England/Itin_1.jpeg";
import pictureTwo from "./../../img/England/Itin_3.jpeg";
import pictureThree from "./../../img/England/Itin_4.jpeg";

function ItalyItinerary() {
  const tripOne = [
    {
      day: "Day 1, Monday, 6/1",
      text: ["Depart on evening flight from the USA"]
    },
    {
      day: "Day 2, Tuesday, 6/2",
      text: [
        "Arrive to London and settle into hotel and rest.",
        "(Hotel near Heathrow Airport)"
      ]
    },
    {
      day: "Day 3, Wednesday, 6/3",
      text: [
        "London: Visit the Museum of Methodism, the Wesley Chapel, the John Wesley’s House, and the grave of John Wesley. Adam Clarke is also buried here. And John Bunyan is buried across the road.",
        "Other places in London as time permits: Thames River, Tower of London Bridge, walk by St Paul’s Cathedral and Buckingham Palace, etc",
        "(Hotel near Heathrow Airport)"
      ]
    },
    {
      day: "Day 4, Thursday, 6/4",
      text: [
        "Today we will travel to the south coast of England to a place called Beachy Head. Here we will walk along the white cliffs (like the White Cliffs of Dover).",
        "After the white cliffs, we will drive to Oxford the home of the world-famous Oxford University and where John and Charles Wesley were students. After getting settled in our hotel, we will begin our tour of Oxford.",
        "(Hotel on northside of Oxford)"
      ]
    },
    {
      day: "Day 5, Friday, 6/5",
      text: [
        "Our tour today will include places in Oxford that were significant in the life of the Wesley brothers where they studied and lived.",
        "We will also visit Magdalen College (part of Oxford University) where C.S Lewis was a professor. We will walk “Addison’s Walk, a picturesque footpath around a small island in the River Cherwell in the grounds of Magdalen College. It was a favoured walk of C.S. Lewis.",
        "We will endeavour to take a tour of the “Kilns” which was the home of C.S Lewis. Sometimes this is possible and at other times not possible. We will see. Holy Trinity Church is nearby, and we will be able to visit the church and graveyard where C.S. Lewis is buried.",
        "In the evening, we will attend Evensong at Christ Church Cathedral at Oxford where Wesley was as an undergraduate student in June 1720.",
        "We will visit other places as time permits.",
        "(Hotel on northside of Oxford)"
      ]
    },
    {
      day: "Day 6, Saturday, 6/6",
      text: [
        "After leaving Oxford we will drive to Bath but make a stop in the beautiful Cotswolds where we will have lunch. In the evening, we will stroll around downtown Bath and eat together in one of the many restaurants near the River Avon.",
        "(Hotel near Bath)"
      ]
    },
    {
      day: "Day 7, Tuesday, Sunday, 6/7",
      text: [
        "Today we will tour Bath. There are various possibilities for activities and sites to be scene. We will make a group decision as to what we will do this day.",
        "(Hotel near Bath)"
      ]
    },
    {
      day: "Day 8, Monday, 6/8",
      text: [
        "Traveling to nearby Bristol, we will discover the world’s oldest Methodist building in the centre of Bristol, John Wesley’s New Room – the Room that changed the world.  Three hundred years ago, John Wesley started a mission here that sparked a worldwide movement. We will visit his 18th century chapel and his room where he lived while in Bristol.",
        "After this we will drive across town to the George Mueller Estate where you can sit at the very desk where George Mueller studied his Bible and prayed with thousands of orphans.",
        "Late afternoon we will drive to Wales where we will stay the night in Swansea.",
        "(Hotel in Swansea)"
      ]
    },
    {
      day: "Day 9, Tuesday, 6/9",
      text: [
        "Our travels today will take us to Moriah Chapel where the great Welsh revival of 1904-1905 broke out under the leadership of the young Evan Roberts. In this revival, 100,000 people were converted in just one year. We will visit the grave of Evan Roberts on the church grounds.",
        "In the afternoon we will drive to the National Trust-Shossili and South Gower Coast. We will stroll along the cliffs of this beautiful park with it’s great views of the ocean below.",
        "(Hotel in Swansea)"
      ]
    },
    {
      day: "Day 10, Wednesday, 6/10",
      text: [
        "Drive back to London/airport hotel with a stop at Stonehenge",
        "(Hotel near Heathrow Airport)"
      ]
    },
    {
      day: "Day 11, Thursday, 6/11",
      text: ["Take a morning flight home to the USA"]
    }
  ];

  const [justTrip, setJustTrip] = useState(false);
  const tripExample = [
    {
      day: "Day 1",
      text: ["Depart the USA."]
    },
    {
      day: "Day 2",
      text: [
        "Arrive in London and settle into our hotel, visit with the group, and rest."
      ]
    },
    {
      day: "Day 3",
      text: [
        "London: Visit the Museum of Methodism, the Wesley Chapel, John Wesley’s house, and the grave of John Wesley. Adam Clarke is also buried here. Across the street is the Bunhill Fields Burial Grounds where Susannah Wesley and John Bunyon are buried. We will walk along Aldersgate Street.",
        "Other places will be visited as time permits."
      ]
    },
    {
      day: "Day 4",
      text: [
        "In the morning drive from London to Epworth where Samuel and Susannah Wesley pastored and raised their children.",
        "In the afternoon we will tour the house and grounds of the Wesley home. This is the house where John (at the age of 5) was saved as a “brand plucked from the burning” when the house caught fire.",
        "In the evening, we will lodge at the quaint Red Lion Inn in Epworth where John Wesley stayed on occasion."
      ]
    },
    {
      day: "Day 5",
      text: [
        "On this day, we will drive to Oxford, the home of the world-famous Oxford University where John and Charles Wesley were students. After getting settled in our hotel, we will begin our tour of Oxford. In the evening, we plan to visit Christ Church Cathedral and take in Evensong at 6:00 PM"
      ]
    },
    {
      day: "Day 6",
      text: [
        "Our tour will include a guided tour of Oxford. We will walk by places that were significant in the life of the Wesley brothers while at Oxford.",
        "We will also visit Magdalen College (part of Oxford University) where C.S Lewis was a professor. We will walk “Addison’s Walk, a picturesque footpath around a small island in the River Cherwell in the grounds of Magdalen College. It was a favoured walk of C.S. Lewis.",
        "We will endeavour to take a tour of the “Kilns” which was the home of C.S Lewis. Sometimes this is possible and at other times not possible. We will see. Holy Trinity Church is nearby, and we will be able to visit the church and graveyard where C.S. Lewis is buried.",
        "We will visit other places as time permits."
      ]
    },
    {
      day: "Day 7",
      text: [
        "After leaving Oxford we will drive to Bath but make a stop in the beautiful Cotswolds where we will have lunch with our own food. In the late afternoon, we will stroll around downtown Bath. Later we will drive to Bristol where we will stay overnight."
      ]
    },
    {
      day: "Day 8",
      text: [
        "In Bristol we will discover the world’s oldest Methodist building, John Wesley’s New Room—the Room that changed the world. Three hundred years ago, John Wesley started a mission here that sparked a worldwide movement. We will visit his 18th-century chapel and the room where he lived while in Bristol.",
        "After this, we will drive across town to the George Mueller Estate and small museum where Mueller ran his orphanages and where you can sit at the desk where he studied his Bible and prayed with thousands of orphans."
      ]
    },
    {
      day: "Day 9",
      text: [
        "Drive back to London/airport hotel with a stop or two as time permits. These stops may include Stonehenge and/or the White Cliffs of Beachy Head (similar to the White Cliffs of Dover)."
      ]
    },
    {
      day: "Day 10",
      text: ["Fly back to the USA."]
    }
  ];

  const params = useParams();

  let dates = "";
  let itinerary = "";
  let trip = [];
  console.log(params.trip);

  switch (params.trip) {
    case "June_1-11-26":
      dates = "June 1 - 11, 2026";
      trip = tripOne;
      break;

    case "trip":
      dates = "";
      trip = tripExample;
      break;
  }

  useEffect(() => {
    if (params.trip === "trip") {
      setJustTrip(true);
      console.log(trip);
    } else {
      setJustTrip(false);
      console.log(trip);
    }
  }, []);
  return (
    <div className="pageContainer">
      <p className="title">Itinerary</p>
      <p className="secondaryTitle">{dates}</p>
      {!justTrip ? (
        <div className="printBox">
          {/* <div className="print">
            <a href={itinerary} target="_blank" rel="noreferrer">
              Print PDF
            </a>
          </div> */}
        </div>
      ) : (
        ""
      )}
      <div className="pictureRow">
        <div>
          <img className="picture" src={pictureOne} alt="Poland town" />
        </div>
        <div className="hide">
          <img className="picture" src={pictureTwo} alt="Poland solt mines" />
        </div>
        <div>
          <img className="picture" src={pictureThree} alt="Polamd mountains" />
        </div>
      </div>

      {trip.map((el, id) => (
        <div key={id}>
          <h2 className={styles.dayNumber}>{el.day}</h2>
          {el.text.map((par) => (
            <p className="text">{par}</p>
          ))}
        </div>
      ))}
    </div>
  );
}

export default ItalyItinerary;
